<!-- 보관함 -->
<template>
  <div>
    <div class="MyCash" v-if="$store.state.mberInfo.mberNo">
      <ul>
        <li>나의 카드 <span>{{ prepaidCardOverview.totalCount }}</span>개</li>
        <li>잔액 <span>{{ prepaidCardOverview.totalRemainCash }}</span>원</li>
      </ul>
    </div>
    <div class="save-box">
      <ul class="save-button-list" @click="handlerButtonClick">
        <li><button class="active" data-index="0" aria-selected="true">전체</button></li>
        <li><button data-index="1">사용가능</button></li>
        <li><button data-index="2">유효기간 만료</button></li>
        <li><button data-index="3">사용중지</button></li>
      </ul>
      <h2 class="blind">{{tabText}}</h2>
      <div v-if="cardBoxList.length === 0" class="save-not-coupon">
        <em class="icon-round-tooltip"></em>
        <span>사용가능한 잔액관리형 쿠폰이 없습니다.</span>
      </div>
      <div v-if="cardBoxList.length !== 0" class="save-info">
        <span>총 <em>{{ totalRows }}</em>개</span>
        <select @change="getPrepaidCardBox()" v-model="orderCriteria" title="정렬 선택" required>
          <option selected v-for="item in orderConditionList" :value="item.orderCriteria">
            {{ item.orderName }}
          </option>
        </select>
      </div>
    </div>

    <ul v-if="cardBoxList.length !== 0" class="save-list">
      <li v-for="card in cardBoxList" class="save-item">
        <div class="save-item-left">
          <a href="javascript:void(0);" @click="moveToCardDetail(card)">
            <div class="item-image card-image" :class="card.status !== 'ACTIVATION'? 'image-filter': null" :style="{ backgroundImage:'url('+card.thumbnailImageUrl+')'}">
              <span class="blind">{{card.thumbnailImageDesc}}</span>
            </div>
            <span class="save-item-text" v-if="card.status === 'EXPIRATION' || card.status === 'DISCARD'">만료</span>
            <span class="save-item-text" v-else-if="card.status === 'LOCKED' && !card.refundStatus">사용중지</span>
            <span class="save-item-text" v-else-if="card.status === 'LOCKED' && card.refundStatus && card.refundStatus === 'REQUEST'">환불요청</span>
            <span class="save-item-text" v-else-if="card.status === 'LOCKED' && card.refundStatus && card.refundStatus === 'PROCESSING'">환불진행중</span>
          </a>
        </div>
        <div class="save-item-right">
          <div class="save-item-birth">
            <a href="javascript:void(0);" @click="moveToCardDetail(card)">
              <span>{{card.prepaidCardNickName != null? card.prepaidCardNickName : card.giftMessage != null? card.giftMessage : ''}}</span>
            </a>
            <button v-if="card.representative && card.status === 'ACTIVATION'" class="icon-star" aria-label="즐겨찾기 해제하기"></button>
            <button v-else-if="!card.representative && card.status === 'ACTIVATION' && card.remainCash > 0" class="icon-star-gray" aria-label="즐겨찾기 선택하기" @click="toggleChangeRepresentativePopup(card)"></button>
            <button v-else-if="!card.representative && card.status === 'ACTIVATION' && card.remainCash === 0" class="icon-trash" @click="toggleHideCardPopup(card.prepaidCardNo)"></button>
            <button v-else-if="card.status === 'LOCKED' && !card.refundStatus" @click="$router.push({name:'stopUsingCancel', params:{cardInfo: card}})">취소</button>
            <button v-else-if="card.status === 'EXPIRATION' || card.status === 'DISCARD'" class="icon-trash" @click="toggleHideCardPopup(card.prepaidCardNo)"></button>
          </div>
          <div class="save-item-price">
            <a href="javascript:void(0);" @click="moveToCardDetail(card)">
              <strong>{{ Number(card.remainCash).toLocaleString() }}</strong>
              <br>
              <span v-if="card.expirationEndDate !== null">~{{ card.expirationEndDate }}</span>
              <div>
                <em v-if="card.status === 'ACTIVATION'">사용가능</em>
                <em v-if="card.gift">선물</em>
<!--                <em v-if="card.goodsType === 'B2B' && card.prepaidCardNo.substr(0, 6) != '321198'">B2B</em>-->
                <em v-if="card.goodsType === 'B2B' && card.goodsName != '신세계 유니버스 클럽'">B2B</em>
              </div>
            </a>
          </div>
          <span v-if="card.status === 'LOCKED' && card.refundRequestDate" class="save-stop-text">환불 신청일<em>{{ card.refundRequestDate }}</em></span>
          <span v-else-if="card.status === 'LOCKED' && !card.refundRequestDate" class="save-stop-text">사용중지 신청일<em>{{ card.changeDate }}</em></span>
          <div class="save-item-line"></div>
        </div>
      </li>
    </ul>
    <pagination
      :totalRows="totalRows"
      :pageModel="prepaidCardBoxRequest"
      v-on:movePage="movePage"
    />
    <div class="use-box-wrap">
      <ul>
        <li class="use-box-item" @click="$router.push({name:'emarticonRegistration'})" tabindex="0">
          <div class="use-item-left">
            <span class="icon-emarticon-card"></span>
            <span class="use-item-text">이마티콘 등록</span>
          </div>
          <span class="icon-chevron-right"></span>
        </li>
        <li v-if="emarticonMberPwdPolicy.certified" class="use-box-item" @click="$router.push({name: 'setting'})" tabindex="0">
          <div class="use-item-left">
            <span class="icon-setup-emarticon"></span>
            <span class="use-item-text">이마티콘 설정</span>
          </div>
          <span class="icon-chevron-right"></span>
        </li>
        <li class="use-box-item" @click="$router.push({name:'emarticonBefore2023'})" tabindex="0">
          <div class="use-item-left">
            <span class="icon-change-card"></span>
            <span class="use-item-text">2023년까지 구매한 이마티콘</span>
          </div>
          <span class="icon-chevron-right"></span>
        </li>
      </ul>
    </div>
    <change-representative-popup
      v-if="showChangeRepresentativePopup"
      :card-name="cardName"
      v-on:toggleChangeRepresentativePopup="toggleChangeRepresentativePopup"
      v-on:changeRepresentativeCard="changeRepresentativeCard"
    />
    <hide-card-popup
      v-if="showHideCardPopup"
      v-on:toggleHideCardPopup="toggleHideCardPopup"
      v-on:hideCard="hideCard"
    />
    <alert-popup v-if="alertPopupShow" :message="alertPopupMessage"  @confirmPopupClickConfirm="confirmPopupClickConfirm" />
  </div>
</template>

<script>
import GrayLine from '@/components/common/GrayLine.vue';
import ChangeRepresentativePopup from '@/views/myemarticon/changeRepresentativePopup.vue';
import HideCardPopup from '@/views/myemarticon/hideCardPopup.vue'
import apiList from "@/api/apiList";
import Pagination from "@/components/common/Pagination";
import commonScripts from '@/plugins/commonScripts';
import AlertPopup from "@/views/myemarticon/alertPopup";

export default {
  name: 'SaveBox',
  components: {AlertPopup, Pagination, GrayLine, ChangeRepresentativePopup, HideCardPopup},
  data() {
    return {
      tabActiveIdx: 0,
      showChangeRepresentativePopup: false,
      showHideCardPopup: false,
      cardBoxList: [],
      prepaidCardBoxRequest: {
        orderCriteria: null,
        size: '10',
        pageNo: '1'
      },
      prepaidCardNo: '',
      totalRows: 0,
      cardName: '',
      orderCriteria: '',
      tabText: '전체',
      orderConditionList: [
        { "orderCriteria": "", "orderName": "기본" },
        { "orderCriteria": "REMAIN_ASC", "orderName": "잔액 적은순" },
        { "orderCriteria": "REMAIN_DESC", "orderName": "잔액 많은순" }
      ], //카드 정렬조건
      emarticonMberPwdPolicy: {certified: false},
      isEmarticonPasswordEnabled: false,
      prepaidCardOverview: {
        totalCount: 0,
        totalRemainCash: 0,
      },
      alertPopupShow: false,
      alertPopupMessage: ""
    }
  },
  mounted() {
    this.$heading('카드 보관함');
    this.getPrepaidCardBox();
    this.getAdminMberPwdPolicy();
    this.getPrepaidCardOverview();
  },
  computed: {
    //선불카드 정렬
    cardOrderCal() {
      if (this.cardOrder == 'desc') {
        return this.cardBoxList.sort((a, b) => a.remainCash - b.remainCash)
      } else {
        return this.cardBoxList.sort((a, b) => b.remainCash - a.remainCash)
      }
    }
  },
  methods: {
    /**
     * 카드 보관함 호출
     */
    async getPrepaidCardBox() {
      try {
        this.prepaidCardBoxRequest.isMberPwdAuthenticated = this.$store.state.isMberPwdAuthenticated;
        if(this.orderCriteria !== null && this.orderCriteria !== '') {
          this.prepaidCardBoxRequest.orderCriteria = this.orderCriteria;
        }

        // this.orderName = this.orderConditionList.find(x => x.orderCriteria == this.orderCriteria).orderName; //웹접근성 title용

        const res = await apiList.getPrePaidCardBox(this.prepaidCardBoxRequest);
        this.cardBoxList = res.data.data.list;
        this.totalRows = res.data.data.totalRows;
        // 정렬기준 초기화
        this.prepaidCardBoxRequest.orderCriteria = '';
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 사용가능, 만료, 사용중지, 환불완료 토글버튼 동작
     */
    handlerButtonClick(e) {
      const { target } = e;
      const index = + target.dataset.index;
      const  ul = document.querySelector('.save-button-list');
      for(let i = 0; i < ul.children.length; i++) {
        const button =  ul.children[i].children[0];
        // i !== index ? button.classList.remove('active') : button.classList.add('active');
        if(i == index) { //웹접근성 조치
          button.classList.add('active');
          button.ariaSelected = true;
          this.tabText = button.textContent; //웹접근성 조치
        } else {
          button.classList.remove('active');
          button.ariaSelected = false;
        }
      }
      if(index === 0) {
        this.prepaidCardBoxRequest.status = null;
        this.prepaidCardBoxRequest.pageNo = 1;
        this.getPrepaidCardBox();
      } else if(index === 1) {
        this.prepaidCardBoxRequest.status = 'ACTIVATION';
        this.prepaidCardBoxRequest.pageNo = 1;
        this.getPrepaidCardBox();
      }
      else if(index === 2) {
        this.prepaidCardBoxRequest.status = 'EXPIRATION';
        this.prepaidCardBoxRequest.pageNo = 1;
        this.getPrepaidCardBox();
      }
      else if(index === 3) {
        this.prepaidCardBoxRequest.status = 'LOCKED';
        this.prepaidCardBoxRequest.pageNo = 1;
        this.getPrepaidCardBox();
      }
    },
    /**
     * 대표카드 변경 팝업 노출
     */
    toggleChangeRepresentativePopup(cardInfo) {
      this.showChangeRepresentativePopup = !this.showChangeRepresentativePopup;
      if(!cardInfo) {
        return;
      }
      this.cardName = cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '이마티콘 카드' //TODO 기본카드명??
      if(this.showChangeRepresentativePopup) {
        this.prepaidCardNo = cardInfo.prepaidCardNo;
      }
    },
    /**
     * 카드 삭제 팝업 노출
     */
    toggleHideCardPopup(prepaidCardNo) {

      //카드 삭제 팝업 호출 시 카드타입 B2B, 카드상태 활성화, 잔액 0원이면 삭제 불가능으로 경고 팝업 호출(현업 확인 완료)
      // 2025.11.11 B2B 활성화 카드도 삭제 가능하도록 변경 요청, 유니버스클럽카드 제외하고 0원인 경우 삭제 가능
      const hideCardCheck = this.cardBoxList.find((card) => {
        if(card.prepaidCardNo === prepaidCardNo && card.status === 'ACTIVATION' && card.remainCash === 0 && card.goodsName === "신세계 유니버스 클럽") {
          return true;
        }
        return false;
      })

      //hideCardCheck - true 이면 삭제 불가능으로 경고 팝업 호출
      if(hideCardCheck) {
        this.alertPopupMessage = "유효기간이 남아있는 카드는 유효기간 만료 후 삭제가 가능합니다.";
        this.alertPopupShow = true;
      } else {
        this.showHideCardPopup = !this.showHideCardPopup;
        if(this.showHideCardPopup) {
          this.prepaidCardNo = prepaidCardNo;
        }
      }
    },
    /**
     * 대표카드 변경 API 호출
     */
    async changeRepresentativeCard() {
      try{
        await apiList.putRepresentativeCard({prepaidCardNo: this.prepaidCardNo});
        this.showChangeRepresentativePopup = false;
        await this.getPrepaidCardBox();
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 카드 삭제 API 호출
     */
    async hideCard() {
      try{
        // 숨김처리 API 호출 시 activePrepaidCardDisplay - true 활성화카드 숨김처리, remainCashCheck - true 잔액 체크(0원일 경우만 처리 가능) params 추가
        const response = await apiList.putPrepaidCardHide({prepaidCardNo: this.prepaidCardNo}, {activePrepaidCardDisplay: true, remainCashCheck: true});

        if (response.data && response.data.code === 'S00000') {
          this.showHideCardPopup = false;
          await this.getPrepaidCardBox();
        } else {
          this.showHideCardPopup = false;
          this.alertPopupMessage = response.message;
          this.alertPopupShow = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    moveToCardDetail(card) {
      if(card.status === 'ACTIVATION' || card.status === 'EXPIRATION' || (card.status === 'LOCKED' && !card.refundStatus)) {
        this.$router.push({name:'cardDetail', params: {prepaidCardNo: card.prepaidCardNo}});
      }
    },
    movePage(pageNo) {
      this.prepaidCardBoxRequest.pageNo = pageNo;
      this.getPrepaidCardBox();
    },
    /**
     * 관리자 비밀번호 정책 조회
     */
    async getAdminMberPwdPolicy() {
      const adminRes = await apiList.getAdminMberPwdPolicy({ctmmnyNo: this.$store.state.partnerId});
      this.emarticonMberPwdPolicy = adminRes.data.data;
      if (!this.emarticonMberPwdPolicy.certified) {
        this.$store.commit('setIsMberPwdAuthenticated');
      }
      if(this.$store.state.nativeStore.isApp) {
        this.setIsEmarticonPasswordEnabled();
      }
    },
    /**
     * 기간별 이마티콘 비밀번호 사용여부 설정
     */
    setIsEmarticonPasswordEnabled() {
      const device = this.$store.state.nativeStore.device;
      const appVer = this.$store.state.nativeStore.appVer;
      const today = new Date();

      const firstBeginDate = new Date('2025-01-21T00:00:00');
      const secondBeginDate = new Date('2025-02-17T00:00:00');
      const thirdBeginDate = new Date('2025-04-01T00:00:00');

      let isNewVersion;
      if (device === 'and') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.1.2');
      } else if (device === 'ios') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.0.9');
      }

      if (today < firstBeginDate){
      } else if (today >= firstBeginDate && today < secondBeginDate) {
        // 구버전: 비번/생체 사용 x
        // 신버전: 비번/생체 사용 가능
        if (!isNewVersion) {
          this.emarticonMberPwdPolicy.certified = false;
          this.$store.commit('setIsMberPwdAuthenticated');
        }
      } else if (today >= secondBeginDate && today <= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용 가능
      } else if (today >= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용
      }
    },
    /**
     * 선불카드 개요 조회
     */
    async getPrepaidCardOverview() {
      try {
        const param = {
          mberNo: this.$store.state.mberInfo.mberNo,
          maximumRows: 150
        }
        const res = await apiList.getPrepaidCardOverview(param);
        this.prepaidCardOverview.totalCount = res.data.data.totalCount;
        this.prepaidCardOverview.totalRemainCash =  new Intl.NumberFormat('ko-KR', { style: 'decimal' }).format(res.data.data.totalRemainCash);
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 경고 팝업 닫기
     */
    confirmPopupClickConfirm() {
      this.alertPopupShow = false;
      this.alertPopupMessage = "";
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/myemarticon/saveBox.scss';
@import '@/assets/styles/common/useBox.scss';
@import '@/assets/styles/common/setup.scss';
</style>
